import { Theme } from '@mui/material/styles';
import { isFunction } from 'lodash';
import { makeStyles } from 'tss-react/mui';

type StyleRules = Record<string, unknown>;
type Classes = { [className: string]: string };

type ComponentStyleStatic = StyleRules;

interface ComponentStylesThemed<Props> {
  (theme: Theme, props: Props): StyleRules;
}

type ComponentStyles<Props> = ComponentStyleStatic | ComponentStylesThemed<Props>;

/**
 * Thin compatibility wrapper over tss-react `makeStyles`.
 * Keeps the previous call-site API: `const classes = useStyles(props?)`.
 */
export const muiStyles = <Props extends Record<string, any> = Record<string, never>>(
  styles: ComponentStyles<Props>,
): ((props?: Props) => Classes) => {
  const useTssStyles = isFunction(styles)
    ? makeStyles<Props>()((theme, props) => styles(theme, props) as any)
    : makeStyles<Props>()(((_theme, _props) => styles) as any);

  return (props?: Props) => {
    const { classes } = useTssStyles((props || {}) as Props);
    return classes as Classes;
  };
};
